/**
 * TanStack Query hooks for `payment-provider-integration-for-influencer-payouts`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	paymentProviderIntegrationForInfluencerPayoutsQueryKeys,
	type CreatePaymentProviderIntegrationForInfluencerPayoutsBody,
	type ListPaymentProviderIntegrationForInfluencerPayoutsResponse,
	type PaymentProviderIntegrationForInfluencerPayoutsRow,
} from "./api";

export function usePaymentProviderIntegrationForInfluencerPayoutsList(): UseQueryResult<ListPaymentProviderIntegrationForInfluencerPayoutsResponse, Error> {
	return useQuery({
		queryKey: paymentProviderIntegrationForInfluencerPayoutsQueryKeys.list(),
		queryFn: list,
	});
}

export function usePaymentProviderIntegrationForInfluencerPayoutsCreate(): UseMutationResult<PaymentProviderIntegrationForInfluencerPayoutsRow, Error, CreatePaymentProviderIntegrationForInfluencerPayoutsBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: paymentProviderIntegrationForInfluencerPayoutsQueryKeys.all });
		},
	});
}

export function usePaymentProviderIntegrationForInfluencerPayoutsDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: paymentProviderIntegrationForInfluencerPayoutsQueryKeys.all });
		},
	});
}
